import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {BytesPipe} from "./bytes.pipe";
import {ElementResizedDirective} from "./element-resized.directive";
import {ErrorModalOutletComponent} from "./error-modal-outlet.component";
import {FlyErrorHandler} from "./fly-error-handler.service";
import {FormErrorsComponent} from "./form-errors.component";
import {LoadingComponent} from "./loading.component";
import {ModalComponent} from "./modal.component";
import {MomentDatePipe} from "./moment-date.pipe";
import {MoneyPipe} from "./money.pipe";
import {NotFoundComponent} from "./not-found.component";
import {PageMessageService} from "./page-message.service";
import {SimpleModal} from "./simple-modal.component";
import {FeatureFlagService} from "./feature-flag.service";

@NgModule({
	imports: [
		CommonModule,
	],
    exports: [
        BytesPipe,
        LoadingComponent,
        ElementResizedDirective,
        ErrorModalOutletComponent,
        FormErrorsComponent,
        ModalComponent,
        MomentDatePipe,
        MoneyPipe,
        NotFoundComponent,
        SimpleModal,
    ],
    declarations: [
        BytesPipe,
        LoadingComponent,
        ElementResizedDirective,
        ErrorModalOutletComponent,
        FormErrorsComponent,
        ModalComponent,
        MomentDatePipe,
        MoneyPipe,
        NotFoundComponent,
        SimpleModal,
    ],
	providers: [
		FlyErrorHandler,
		PageMessageService,
		FeatureFlagService,
	],
})
export class FlyCommonModule { }
